import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";

export default function useTrackUtmVisit() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get("utm_source");
    const utmMedium = params.get("utm_medium");
    const utmCampaign = params.get("utm_campaign");

    if (utmSource) {
      let visitorId = localStorage.getItem("visitorId");
      if (!visitorId) {
        visitorId = uuidv4();
        localStorage.setItem("visitorId", visitorId);
      }

      localStorage.setItem("utmSource", utmSource);
      localStorage.setItem("utmMedium", utmMedium || "");
      localStorage.setItem("utmCampaign", utmCampaign || "");

      fetch("https://webhook-whatsapp.eduassistance.co/api/tracking/event", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          visitorId,
          utmSource,
          utmMedium,
          utmCampaign,
          eventType: "VISIT",
        }),
      }).catch((err) => console.error("Tracking error", err));
    }
  }, []);
}
